import type { ReactNode } from 'react';
import { PageHeader, PageRouteScaffold, StatusPage, type StatusPageProps } from '@wapharma/design-system';
import styles from './AdminStatusPage.module.css';

export type AdminStatusPageProps = {
  variant: StatusPageProps['variant'];
  title: string;
  description?: ReactNode;
  children?: ReactNode;
  breadcrumbs?: Array<{ label: string; href?: string }>;
  /** crash = full viewport (error boundary); route = inside admin shell */
  mode?: 'route' | 'crash';
};

export function AdminStatusPage({
  variant,
  title,
  description,
  children,
  breadcrumbs,
  mode = 'route',
}: AdminStatusPageProps) {
  const statusClassName =
    mode === 'crash'
      ? 'hamssah-status-page admin-status--crash'
      : 'hamssah-status-page admin-status--embedded';

  const status = (
    <div className={styles.statusHost}>
      <StatusPage
        className={statusClassName}
        variant={variant}
        title={title}
        description={description}
        illustrationSize="lg"
        illustrationTone="soft"
      >
        {children}
      </StatusPage>
    </div>
  );

  if (mode === 'crash') {
    return <div className={styles.crashShell}>{status}</div>;
  }

  return (
    <PageRouteScaffold
      band={
        <PageHeader
          title={title}
          breadcrumbs={breadcrumbs ?? [{ label: 'Accueil', href: '/' }, { label: title }]}
          variant="dock"
        />
      }
    >
      {status}
    </PageRouteScaffold>
  );
}
